import React, { FC, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './CategoriesGrid.module.scss';
import { CategoriesModel } from '../../pages/home/query/types';
import { generateImageUrl } from '../../utils/cdnService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../context/auth';
import { loginRedirection } from '../../context/auth/utils';


interface Props {
  categories: CategoriesModel[];
  forceKategorienRoute?: boolean;
}

const CategoriesGrid: FC<Props> = ({ categories, forceKategorienRoute }) => {
  const navigate = useNavigate();
  const { i18n: { language } } = useTranslation();
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;

  const handleCategoryClick = (categoryId: number) => {
    // For non-authenticated users, stay on movies page (shows categories grid)
    if (!isAuthenticated) {
      loginRedirection();
    } else if (forceKategorienRoute) {
      // For separate kategorien page
      navigate(`/${language}/kategorien`);
    } else {
      // For authenticated users, go to the specific category
      navigate(`/${language}/tag/${categoryId}`);
    }
  };

  return (
    <div className={styles.gridContainer}>
      <Row className={styles.categoriesRow}>
        {categories.map((category) => (
          <Col key={category.id} xs={6} sm={4} md={3} lg={2} className={styles.categoryCol}>
            <div className={styles.categoryCard} onClick={() => handleCategoryClick(category.id)}>
              <div className={styles.imageWrapper}>
                <img 
                  src={generateImageUrl('gcore', 0, 0, category.image)} 
                  alt={category.name}
                  className={styles.categoryImage}
                />
              </div>
              <div className={styles.categoryName}>
                <h5>{category.name}</h5>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CategoriesGrid;